// extracted by mini-css-extract-plugin
export default {"gosuslugi":"Oqe0V","backgroundFiller":"zEhMT","content":"uh8sl","header":"zBrRI","buttons":"QqEnV","gosuslugiButton":"i4f1o","byHandButton":"Yytbr","cards":"irNex"};